<template>
  <div class="policy-page">
    <h1>Fair Use Policy</h1>

    <p>
      This Fair Use Policy is intended to ensure that all users of the Pathtracer platform have a reliable and performant experience.
    </p>

    <h2>1. Purpose</h2>
    <p>
      The tools provided by this platform are designed for responsible human use in the context of blockchain analysis, research, and investigations.
    </p>

    <h2>2. Acceptable Use</h2>
    <ul>
      <li>Using the tools for personal, educational, or professional blockchain analysis</li>
      <li>Moderate use of batch or automated analysis features (if available)</li>
      <li>Adhering to any rate limits or usage guidelines outlined in documentation</li>
      <li>Max pending requests: 100</li>
      <li>Max request history: 150</li>
    </ul>

    <h2>3. Prohibited Behavior</h2>
    <ul>
      <li>Excessive automated requests (e.g., botting, scraping, brute force queries)</li>
      <li>Sharing access tokens or credentials with unauthorized users</li>
      <li>Using the platform to interfere with the service availability of others</li>
    </ul>

    <h2>4. Enforcement</h2>
    <p>
      If your usage is flagged as excessive or abusive — even under a subscription or unlimited access plan — your account may be subject to:
    </p>
    <ul>
      <li>Temporary throttling or request delays</li>
      <li>Manual usage review</li>
      <li>Suspension or termination of access</li>
    </ul>

    <h2>5. Need More?</h2>
    <p>
      If you believe your use case warrants higher usage thresholds, please contact support to discuss enterprise access.
    </p>

    <router-link to="/" class="back-link">← Return to Home</router-link>
  </div>
</template>

<script>
export default {
  name: 'FairUsePolicy'
}
</script>

<style scoped>
.policy-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 24px;
  line-height: 1.6;
}

h1, h2 {
  margin-top: 24px;
  color: #2c3e50;
}

ul {
  padding-left: 20px;
  margin-bottom: 16px;
}

.back-link {
  display: inline-block;
  margin-top: 32px;
  text-decoration: underline;
  color: #3498db;
}

.back-link:hover {
  color: #217dbb;
}
</style>
